import * as api from '../api'
import { FETCH_ALL_PLAYER, CREATE_PLAYER, DELETE_PLAYER, UPDATE_PLAYER, CREATE_PLAYERS } from '../constants/actionTypes.js'
import { contrainteNotification, deleteContrainteNotification, duplicationNotification } from './notifications.js'

// Action creator
export const getPlayers = () => async (dispatch) => {

    try{
        const {data} = await api.fetchPlayers()

        dispatch({ type: FETCH_ALL_PLAYER, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const getPlayersByTeamId = (id) => async (dispatch) => {
    
    try {
        const {data} = await api.fetchPlayersByTeamId(id)

        dispatch({ type: FETCH_ALL_PLAYER, payload: data})
    } catch(error){
        console.log(error.message)
    } 
}

export const mergePlayer = (playerToCreate, originalId) => async (dispatch) => {
    try {
        const formData = new FormData()
        Object.keys(playerToCreate).forEach((key) => {
            if (playerToCreate[key] instanceof Array) {
              for (let i = 0; i < playerToCreate[key].length; i++) {
                const value = playerToCreate[key][i];
                if (typeof value === 'string') {
                  formData.append(`${key}[]`, value);
                } else {
                    formData.append(`${key}[]`, JSON.stringify(value));
                }
              }
            } else {
              let noNull = playerToCreate[key] ?? ""
              formData.append(key, noNull);
            }
          });
        const { data } = await api.mergePlayer(formData, originalId)

        dispatch( { type : CREATE_PLAYER, payload: data})
    } catch(error){
        console.log(error, error.message)
    }
}

export const createPlayer = (player, force = false) => async (dispatch) => {
    try {
        const formData = new FormData()
        Object.keys(player).forEach((key) => {
            if (player[key] instanceof Array) {
              for (let i = 0; i < player[key].length; i++) {
                const value = player[key][i];
                if (typeof value === 'string') {
                  formData.append(`${key}[]`, value);
                } else {
                    formData.append(`${key}[]`, JSON.stringify(value));
                }
              }
            } else {
              let noNull = player[key] ?? ""
              formData.append(key, noNull);
            }
          });
        const { data } = await api.createPlayer(formData, {force})

        dispatch( { type : CREATE_PLAYER, payload: data})
    } catch(error){
        const {error : serverError} = error.response.data

        const {statusCode, type, typeObject, objectToCreate, duplicates} = serverError

        if(statusCode===409 && type==='duplication'){
            // Un autre object doit etre supprimé avant
            dispatch(duplicationNotification(objectToCreate, duplicates, typeObject))
        }

        console.log(error, error.message)
    }
}

export const createPlayers = (players) => async (dispatch) => {
    try {
        const { data } = await api.createPlayers(players)

        dispatch( { type : CREATE_PLAYERS, payload: data})
    } catch(error){

        console.log(error, error.message)
    }
}

export const updatePlayer = (id, player) => async (dispatch) => {
    try {
        const formData = new FormData()
        Object.keys(player).forEach((key) => {
            if (player[key] instanceof Array) {
              for (let i = 0; i < player[key].length; i++) {
                const value = player[key][i];
                if (typeof value === 'string') {
                  formData.append(`${key}[]`, value);
                } else {
                    formData.append(`${key}[]`, JSON.stringify(value));
                }
              }
            } else {
              // Gère le cas du champs null 
              let noNull = player[key] ?? ""
              formData.append(key, noNull);
            }
          });
          //console.log("Sending data", id, formData);

        const { data } = await api.updatePlayer(id, formData)

        dispatch({ type : UPDATE_PLAYER, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const deletePlayer = (id, callback) => async (dispatch) => {
    try {
        await api.deletePlayer(id)

        dispatch(deleteContrainteNotification(id))

        callback(id)

        dispatch({ type : DELETE_PLAYER, payload: id})
    }catch(error){
        const {error : serverError} = error.response?.data

        const {statusCode, type, typeObject, idObject} = serverError

        if(statusCode===409 && type==='constraint'){
            // Un autre object doit etre supprimé avant
            dispatch(contrainteNotification(idObject, typeObject))
        }
    }
}